// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_jm-0";
export var fileCarousel = "_jm-2";
export var removeFileButton = "_jm-1";